import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import api from "../../api/api";

export const addValuatorPersonalDetails = createAsyncThunk(
	"ValuatorPersonalDetails/add",
	async (data) => {
		try {
			const response = await api.post(`/v1/ValuatorPersonal`, data, {
				headers: {
					"Content-Type": "application/json",
				},
			});
			toast.success("Profile added successfully!");
			return response.data?.data || response.data;
		} catch (error) {
			const res = error.response.data?.data;
			if (res?.Errors && Array.isArray(res.Errors)) {
				res.Errors.forEach((err) => {
					toast.error(err);
				});
			} else {
				toast.error(res?.Message || "Failed to add Profile Detailse");
			}
		}
	},
);
const ValuatorPersonalDetailSlice = createSlice({
	name: "valuatorPersonalDetail",
	initialState: {
		data: [],
		selected: null,
		loading: false,
		error: null,
		successMessage: null,
	},
	reducers: {
		clearValuator(state) {
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder
			//add
			.addCase(addValuatorPersonalDetails.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(addValuatorPersonalDetails.fulfilled, (state, action) => {
				state.loading = false;
				state.successMessage = "Profile added successfully";
				state.data.push(action.payload);
			})
			.addCase(addValuatorPersonalDetails.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload;
			});
	},
});

export const { clearValuator } = ValuatorPersonalDetailSlice.actions;

export default ValuatorPersonalDetailSlice.reducer;
